import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';

export const activityResources = {
  getActivity: createResourceBuilder('/admin/analytics/activity', EResourceMethod.Get),
  getIpActivity: createResourceBuilder('/admin/analytics/activity/account', EResourceMethod.Get),
};
